<template>
  <div>
    <div class="cake-layout">
      <router-view></router-view>
    </div>
    <layoutTabbar :tab-list="tabList"></layoutTabbar>
  </div>
</template>
<script>
import layoutTabbar from '@/components/Tabbar.vue';
import { cakeTabMap } from '@/router/routes/cakeMap.js';


export default {
  components: {
    layoutTabbar
  },
  computed: {
    tabList () {
      const list = cakeTabMap[0].children.map(item => {
        return {
          name: item.meta.name,
          path: item.path,
          icon: {
            active: item.icon.active,
            inactive: item.icon.inactive
          }
        }
      })
      return [
      {
        name: '商城首页',
        path: '/tabbar/home',
        icon: {
         	active: require('@/assets/Tabbar/achome.svg'),
					inactive: require('@/assets/Tabbar/home.svg')
        }
      }, ...list]
    }
  },
}
</script>
<style lang="scss" scoped>
  .cake-layout{
    padding-bottom: 1rem;
    background: $cake-primary-bg;
    min-height: calc(100vh - 1rem);
  }
</style>